import * as React from 'react';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import CircleImage from '../components/CircleImage';
import GlobalModal from './GlobalModal';
import EditProfileImage from './EditProfileImage';
import DisplayDate from './DisplayDate';
import DisplayPhoneNumber from './DisplayPhoneNumber';

// ICONS
import { ReactComponent as EditIcon } from '../assets/svg/edit.svg';

interface ProfileSummaryTypes {
	id?: string;
	profileImage?: string;
	firstName?: string;
	lastName?: string;
	childAwareId?: number;
	email?: string;
	dateOfBirth?: string;
	phoneNumber?: string;
	canUpdate?: boolean;
	canUpdateProfileImage?: boolean;
	isUpdated?: React.Dispatch<React.SetStateAction<boolean>>;
	isStudent?: boolean;
	isPastProfile?: boolean;
}

const ProfileSummary: React.FC<ProfileSummaryTypes> = ({
	id,
	profileImage,
	firstName,
	lastName,
	childAwareId,
	email,
	phoneNumber,
	dateOfBirth,
	canUpdate,
	canUpdateProfileImage,
	isUpdated,
	isStudent,
	isPastProfile
}) => {
	const [showEditModal, setShowEditModal] = React.useState<boolean>(false);
	const [isMounted, setIsMounted] = React.useState<boolean>(false);

	React.useEffect(() => {
		setIsMounted(true);
	}, []);

	return (
		<>
			<article className={`staff-profile-summary ${isPastProfile ? 'past-staff' : ''}`}>
				<div className="summary-left">
					<CircleImage
						src={isStudent ? '' : profileImage}
						firstName={firstName}
						lastName={lastName}
						isColorBorder={true}
						textLarge={true}
					/>
				</div>

				<div className="summary-center">
					<h1 className="staff-name">
						{firstName} {lastName}
					</h1>

					{!isPastProfile && (
						<>
							{!isStudent && (
								<div className="staff-detail" onClick={() => setShowEditModal(true)}>
									{canUpdateProfileImage && (
										<>
											<EditIcon className="link-icon" />
											<p className="link-text">Edit profile picture</p>
										</>
									)}

									<div className="row">
										{childAwareId && (
											<div className="col-lg-auto detail-info">
												<div className="general-sub-title">ChildAware ID</div>

												<div className="detail-content">{childAwareId}</div>
											</div>
										)}

										{email && (
											<div className="col-lg-auto detail-info">
												<div className="general-sub-title">Email</div>

												<div className="detail-content">{email}</div>
											</div>
										)}

										{phoneNumber && (
											<div className="col-lg-auto detail-info">
												<div className="general-sub-title">Phone</div>

												<div className="detail-content">
													<DisplayPhoneNumber>{phoneNumber}</DisplayPhoneNumber>
												</div>
											</div>
										)}

										{dateOfBirth && (
											<div className="col-lg-auto detail-info">
												<div className="general-sub-title">Date of Birth</div>

												<div className="detail-content">
													<DisplayDate>{dateOfBirth}</DisplayDate>
												</div>
											</div>
										)}
									</div>
								</div>
							)}

							{canUpdate && (
								<div className="edit-section">
									<Link className="summary-link" to={`/my-account/${id}`}>
										<EditIcon className="link-icon" />

										<p className="link-text">
											Edit your Child<strong>Aware</strong>&nbsp;details in <strong>"My Account"</strong>
										</p>
									</Link>

									<Link className="btn btn-primary" to={`/my-account/${id}`}>
										Edit Profile
									</Link>
								</div>
							)}
						</>
					)}
				</div>
			</article>

			<GlobalModal isOpen={showEditModal} setIsOpen={setShowEditModal} titleText="Edit profile picture">
				<EditProfileImage isUpdated={isUpdated} />
			</GlobalModal>
		</>
	);
};

export default ProfileSummary;
